import angular from 'angular';

class BoUserList {
  /*@ngInject*/
  constructor(KISS_USER) {
    this.allRoles = KISS_USER.boRoleByLevel.map(obj => obj.role).sort();
    this.criteria = {
      text: '',
      userRole: null,
      userStatus: null
    };
  }

  criteriaMatch(criteria) {
    return function(user) {
      var textMatch = true;
      if (criteria.text.length > 0) {
        var textRegExp = new RegExp(criteria.text, 'i');
        textMatch = textRegExp.test(user.login) || textRegExp.test(user.firstname) || textRegExp.test(user.lastname);
      }
      return (
        textMatch &&
        (criteria.userRole == null || (user.roles != null && user.roles.includes(criteria.userRole))) &&
        (criteria.userStatus == null || user.status === criteria.userStatus)
      );
    };
  }
}

angular.module('app.bouser').component('bouserList', {
  templateUrl: require('./bo-user-list.html'),
  controller: BoUserList,
  bindings: {
    boUsers: '<'
  }
});
